import Vue from 'vue';
import { subscribeToEventSource } from '@/assets/js/api/events';
import { getResourceUsage } from '@/assets/js/api/usage-report';
import { getStatus } from '@/assets/js/api/status';
import { formatDistance, subMonths, format, addDays } from 'date-fns';

export default Vue.mixin({
  computed: {
    isLoggedIn() {
      return this.$store.state.misc.isLoggedIn;
    },

    specificService() {
        return false;
        if (this.$store.state.misc.emk && !this.$store.state.misc.cloud) {
            return true;
        } else {
            if (localStorage.getItem('emk') != null && localStorage.getItem('cloud') == null) {
                return true;
            } else {
                return false;
            }
        }
    },

    objectStoreOnly() {
        let data = this.$store.state.misc.objectStore;
        return data;
    },

    deployingEnvironment() {
      return this.$store.state.misc.deployingEnvironment;
    },

    switchingTeam() {
      return this.$store.state.team.switchingTeam;
    },

    pageLoading() {
      return this.$store.state.misc.pageLoading;
    },

    emailVerified() {
      return this.$store.state.user.emailVerified;
    },

    userEmail() {
      return this.$store.state.user.info.email_address;
    },

    hasUser() {
      return this.$store.state.user.hasData;
    },

    hasCustomer() {
      return this.$store.state.customer.hasData;
    },

    hasTenant() {
      return this.$store.state.misc.hasTenant;
    },

    isBetaUser() {
      return this.$store.state.misc.is_beta_user;
    },

    hasAms1() {
      return this.$store.state.misc.hasAms1;
    },

    hasAms2() {
      return this.$store.state.misc.hasAms2;
    },

    isAms2() {
        if (this.$store.state.misc.activeRegion === 'ams2') {
          return true;
        } else {
          return false;
        }
    },

    hasDomainInfo() {
      return this.$store.state.team.hasDomainInfo;
    },

    isHome() {
      return this.$route.fullPath === '/';
    },

    isInbox() {
      return this.$route.fullPath === '/inbox';
    },

    hasOpenstackCredentials() {
      return this.$store.state.osCredentials.hasData;
    },

    hasProjects() {
      return this.$store.state.project.hasData;
    },

    hasTeams() {
      return this.$store.state.team.hasData;
    },

    hasToken() {
      return this.$store.state.services.hasData;
    },

    hasS3Credentials() {
      return this.$store.state.hasS3Credentials;
    },

    hasUsageData() {
      return this.$store.state.usage.hasData;
    },

    hasUsageError() {
      return this.$store.state.usage.hasError;
    },

    hasContainers() {
      if (this.$store.state.objectStore.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    hasContainerDetails() {
      return this.$store.state.objectStore.hasDetails;
    },

    hasObjects() {
      return this.$store.state.objectStore.hasObjects;
    },

    objectStoreIsLoading() {
      return this.$store.state.objectStore.isLoading;
    },

    hasInstances() {
      if (this.$store.state.instance.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    instanceIsLoading() {
      return this.$store.state.instance.isLoading;
    },

    consoleIsLoading() {
      return this.$store.state.instance.consoleIsLoading;
    },

    hasPublicImages() {
      if (this.$store.state.image.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    hasOwnedImages() {
      if (this.$store.state.image.listOwned.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    imageIsLoading() {
      return this.$store.state.image.isLoading;
    },

    hasInstanceDetails() {
      return this.$store.state.instance.hasDetails;
    },

    hasVolumes() {
      if (this.$store.state.volumev3.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    hasVolumeBackups() {
      if (this.$store.state.volumev3.backups.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    volumeBackupsIsLoading() {
      return this.$store.state.volumev3.backupsIsLoading;
    },

    hasVolumeDetails() {
      return this.$store.state.volumev3.hasDetails;
    },

    volumeStoreIsLoading() {
      return this.$store.state.volumev3.isLoading;
    },

    hasLoadBalancer() {
      if (this.$store.state.loadBalancer.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    hasLoadBalancerDetails() {
      return this.$store.state.loadBalancer.hasDetails;
    },

    loadBalancerIsLoading() {
      return this.$store.state.loadBalancer.isLoading;
    },

    listenerIsLoading() {
      return this.$store.state.listener.isLoading;
    },

    poolIsLoading() {
      return this.$store.state.pool.isLoading;
    },

    lbmemberIsLoading() {
      return this.$store.state.lbMember.isLoading;
    },

    ipIsLoading() {
      return this.$store.state.ip.isLoading;
    },

    DNSIsLoading() {
      return this.$store.state.dns.isLoading;
    },

    hasDNS() {
      if (this.$store.state.dns.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    hasSecrets() {
      if (this.$store.state.secrets.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    sercretsIsLoading() {
      return this.$store.state.secrets.isLoading;
    },

    hasDNSRecords() {
        if (this.$store.state.dns.currentRecords && this.$store.state.dns.currentRecords.length > 0) {
          return true;
        } else {
          return false;
        }
    },

    recordKey() {
      return this.$store.state.dns.recordKey;
    },

    hasNetworks() {
      if (this.$store.state.network.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    networkIsLoading() {
      return this.$store.state.network.isLoading;
    },

    hasPorts() {
      if (this.$store.state.port.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    hasDataPorts() {
      return this.$store.state.port.hasData;
    },

    portIsLoading() {
      return this.$store.state.port.list.length > 0;
    },

    routerIsLoading() {
      return this.$store.state.router.isLoading;
    },

    hasRouters() {
      if (this.$store.state.router.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    hasIps() {
      if (this.$store.state.ip.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    subnetIsLoading() {
      return this.$store.state.subnet.isLoading;
    },

    hasSnapshots() {
      return this.$store.state.snapshot.hasData;
    },

    hasFlavors() {
      return this.$store.state.flavor.hasData;
    },

    hasKeyPairs() {
      if (this.$store.state.keyPair.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    keyPairIsLoading() {
      return this.$store.state.keyPair.isLoading;
    },

    hasSecurityGroups() {
      if (this.$store.state.securityGroup.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    securityGroupsIsLoading() {
      return this.$store.state.securityGroup.isLoading;
    },

    hasKubernetes() {
        if (this.$store.state.kubernetes.list.length > 0) {
          return true;
        } else {
          return false;
        }
    },

    kubernetesIsLoading() {
        if (this.$store.state.kubernetes.isLoading) {
            return true;
        } else {
            if (this.$store.state.kubernetes.list.length > 0) {
                return false;
            } else if (this.hasEMKAccess && this.$route.name === 'kubernetes') {
                this.showNotification('info', `Kubernetes service is obsolete. You are redicted to our new service EMK.`);
                this.$router.push({name: 'managed-kubernetes'});
            }
        }
    },

    hasKubernetesDetails() {
      return this.$store.state.kubernetes.hasDetails;
    },

    hasEMKAccess() {
        return this.$store.state.misc.emk;
    },

    teamHasNameSpace() {
        return this.$store.state.emk.teamHasNameSpace;
    },

    hasEMK() {
        if (this.$store.state.emk.list.length > 0) {
            return true;
        } else {
            return false;
        }
    },

    hasEmkSecrets() {
        if (this.$store.state.emk.projectSecrets.length > 0) {
          return true;
        } else {
          return false;
        }
    },

    emkIsLoading() {
      return this.$store.state.emk.isLoading;
    },

    hasCredentials() {
      if (this.$store.state.credential.list.length > 0 || this.$store.state.appCredential.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    credentialIsLoading() {
      return this.$store.state.credential.isLoading;
    },

    hasDatabases() {
      if (this.$store.state.databases.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    databasesIsLoading() {
      return this.$store.state.databases.isLoading;
    },

    hasDatabaseDetails() {
      return this.$store.state.databases.hasDetails;
    },

    showSidebar() {
      return this.$store.state.misc.showSidebar;
    },

    animateCredit() {
      return this.$store.state.misc.animateCredit;
    },

    showCredits() {
      return this.$store.state.misc.showCredits;
    },

    showHelpbar() {
      return this.$store.state.misc.showHelpbar;
    },

    helpTabOpen: {
        get() {
            return this.$store.state.misc.activeHelpTab;
        }
    },

    hasBackups() {
      if (this.$store.state.backup.list.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    backupsIsLoading() {
      return this.$store.state.backup.isLoading;
    },

    backupDetails() {
      return this.$store.state.backup.hasDetails;
    },

    openHelpbar: {
        get() {
            return this.$store.state.misc.showHelpbar;
        },
    },

    hasGpuAccess() {
      if (this.$store.state.flavor.list && this.$store.state.flavor.list.find(item => item.name.startsWith('g2'))) {
          return true;
      } else {
        return false;
      }
    },

    activeTips() {
        let data = this.$store.state.tips.info.find(item => item.tag === this.$route.meta.sidebar);
        if (data) {
            return data;
        } else {
            return false;
        }
    },
  },

  filters: {
      nlFormattedEuros(value) {
          const rounded = (Math.round(value * 100) / 100) / 100;
          let formatted = rounded.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          return '' + formatted;
      },

      usFormattedEuros(value) {
          const rounded = (Math.round(value * 100) / 100) / 100;
          let formatted = rounded.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return '€' + formatted;
      },

      formatName(value) {
          if (value !== undefined && typeof(value) === 'string') {
              return value.replace(/\_/g, ' ');
          } else {
              return value;
          }
      },

      prettyBytes: function (num) {
          if (typeof num !== 'number' || isNaN(num)) {
              return '-';
          }

          var exponent;
          var unit;
          var neg = num < 0;
          var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

          if (neg) {
              num = -num;
          }

          if (num < 1) {
              return (neg ? '-' : '') + num + ' B';
          }

          exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
          num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
          unit = units[exponent];

          return (neg ? '-' : '') + num + ' ' + unit;
      },

      humanTime(dateData, howToShowTime, moreInfo) {
          const timestamp = new Date().getTime()
          let now = new Date(dateData).getTime();
          var dt = new Date(dateData);
          if (!dateData.includes('Z')) {
              dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
          }
          let createdDate = dt.getTime();
          let oneMonthBeforeCreated = subMonths(now, 1).getTime();
          if (!howToShowTime) {
              howToShowTime = 'MMM dd, yyyy';
          }
          let data = format(createdDate, howToShowTime)
          let distanceDate = formatDistance(createdDate, timestamp, {addSuffix: true, includeSeconds: true});
          if (createdDate > oneMonthBeforeCreated) {
            data = distanceDate;
          }
          if (moreInfo) {
            data = format(createdDate, 'LLLL do, yyyy - HH:mm') + '   (' + distanceDate + ')';
          }
          return data;
      },
  },

  notifications: {
    showToastr: {
      title: 'Some notification',
      message: 'Some notification message',
      timeout: 10000
    },
  },

  methods: {
    checkApiStatus() {
      getStatus()
      .then((response) => {
        if (response.status === 200) {
          this.$store.commit('misc/SET_API_STATUS', true);
          if (this.$router.currentRoute.name.includes('50')) {
              this.$router.push({name: 'home'});
          }
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 401) {
          this.$router.push({name: 'logout'});
        } else if (error.response && error.response.status === 500) {
          this.$store.commit('misc/PAGE_LOADING', false);
          this.$router.push({name: '500'});
        } else if (error.response && error.response.status === 502) {
          this.$store.commit('misc/PAGE_LOADING', false);
          this.$router.push({name: '502'});
        } else if (error.response && error.response.status === 503) {
          this.$store.commit('misc/PAGE_LOADING', false);
          this.$router.push({name: '503'});
        }
        setTimeout(() => {
          this.checkApiStatus();
        }, 10000);
      });
    },

    errorMessageFromPromise(responseData, elseMessage) {
        console.log('errorMessageFromPromise responseData ' , responseData)
          responseData.forEach((errorData, i) => {
            console.log('errorMessageFromPromise errorData ' , errorData)
              let error = {response: {data: {}}}
              if (errorData.reason.request && errorData.reason.request.response) {
                  console.log('errorMessageFromPromise reason ' , errorData.reason.request.response)
                  if (typeof(errorData.reason.request.response) === 'string') {
                    error.response.data.message = errorData.reason.request.response;
                  } else {
                    error.response.data = JSON.parse(errorData.reason.request.response);
                  }
                  this.resourceErrorMessage(error, elseMessage)
              } else if (errorData.reason.message) {
                  error.response.data = errorData.reason.message;
                  this.resourceErrorMessage(error, elseMessage)
              }
          });
          this.isLoading = false;
    },

    isTeamOwner(otherEmail) {
        let checkedEmail = this.$store.state.user.info.email_address;
        if (otherEmail != undefined) {
            checkedEmail = otherEmail;
        }
        if (this.$store.state.team.current.owner.email_address === checkedEmail) {
            return true;
        } else {
            return false;
        }
    },

    isCustomerOwner(otherEmail) {
        if (this.hasCustomer) {
            let checkedEmail = this.$store.state.user.info.email_address;
            if (otherEmail != undefined) {
                checkedEmail = otherEmail;
            }
            if (this.$store.state.customer.info.owner.email_address === checkedEmail) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    },

    emkErrorMessage(error, elseMessage) {
        if (error.response && (error.response.status === 401)) {
            this.showNotification('error', 'Unauthorization failed for EMK. Please reload the page or try to login again');
        } else if (error.response && error.response.data && error.response.data.message) {
            let errorMessage = error.response.data.message;
            if (errorMessage.includes('forbidden: ')) {
                errorMessage = errorMessage.split('forbidden: ')[1];
            }
            this.showNotification('error', errorMessage);
        } else {
            this.showNotification('error', elseMessage);
        }
    },

    resourceErrorMessage(error, elseMessage) {
        // error messages for volumev3 and compute
        if (error.response && error.response.data) {
            if (error.response.data.conflictingRequest) {
                this.showNotification('error', `${ error.response.data.conflictingRequest.message }`);
            } else if (error.response.data.badRequest) {
                this.showNotification('error', `${ error.response.data.badRequest.message }`);
            } else if (error.response.data.forbidden) {
                this.showNotification('error', `${ error.response.data.forbidden.message }`);
            } else if (error.response.data.itemNotFound) {
                this.showNotification('error', `${ error.response.data.itemNotFound.message }`);
            } else if (error.response.data.NeutronError) {
                this.showNotification('error', `${ error.response.data.NeutronError.message }`);
            } else if (error.response.data.error && error.response.data.error.message) {
                this.showNotification('error', `${ error.response.data.error.message }`);
            } else if (error.response.data.overLimit) {
                this.showNotification('error', `${ error.response.data.overLimit.message }`);
            } else if (error.response.data.message) {
                this.showNotification('error', `${ error.response.data.message }`);
            } else if (elseMessage) {
                this.showNotification('error', elseMessage);
            } else {
                console.log('Something went wrong: ', error)
                this.showNotification('error', 'Something went wrong');
            }
        } else if (elseMessage) {
            this.showNotification('error', elseMessage);
        } else {
          console.log('Something went wrong: ', error)
          this.showNotification('error', 'Something went wrong');
        }
    },

    showNotification(type, message) {
        let data = {
            "type" : type,
            "message" : message,
        }
        this.$store.commit('misc/SET_NOTIFICATIONS', data);
        if (this.helpTabOpen !== 'notifications') {
            this.showToastr({type: type, title: type, message: message});
            this.$store.commit('misc/NEW_NOTIFICATION', true);
        }
    },

    flavorPricing() {
        let data = [{"name":"t2.micro","price":{"min":"0.0054","max":"3.63"},"ephemeral_read":10,"ephemeral_write":5,"network_average":16384},{"name":"t2.tiny","price":{"min":"0.0081","max":"5.45"},"ephemeral_read":10,"ephemeral_write":5,"network_average":16384},{"name":"t2.small","price":{"min":"0.0108","max":"7.26"},"ephemeral_read":10,"ephemeral_write":5,"network_average":16384},{"name":"t3.small","price":{"min":"0.038671875000","max":"25.99"},"ephemeral_read":10,"ephemeral_write":5,"network_average":16384,"geekbench":{"multicore_score":1730,"score":1760}},{"name":"t3.medium","price":{"min":"0.07734375","max":"51.98"},"ephemeral_read":10,"ephemeral_write":5,"network_average":16384,"geekbench":{"multicore_score":3292,"score":1752}},{"name":"t3.large","price":{"min":"0.1546875","max":"103.95"},"ephemeral_read":10,"ephemeral_write":5,"network_average":16384,"geekbench":{"multicore_score":5912,"score":1765}},{"name":"t4.micro","price":{"min":"0.0053","max":"3.54"},"ephemeral_read":10,"ephemeral_write":5,"network_average":65536},{"name":"t4.tiny","price":{"min":"0.0079","max":"5.32"},"ephemeral_read":15,"ephemeral_write":7.5,"network_average":65536},{"name":"t4.small","price":{"min":"0.0106","max":"7.09"},"ephemeral_read":20,"ephemeral_write":10,"network_average":65536},{"name":"c3.small","price":{"min":"0.045086495536","max":"30.30"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":3089,"score":3171}},{"name":"c3.medium","price":{"min":"0.07980","max":"53.63"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":5974,"score":3176}},{"name":"c3.large","price":{"min":"0.15960","max":"107.25"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":11220,"score":3118}},{"name":"c3.xlarge","price":{"min":"0.32718","max":"219.86"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":19231,"score":3285}},{"name":"c3.2xlarge","price":{"min":"0.50273","max":"337.84"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":25671,"score":3217}},{"name":"c3.4xlarge","price":{"min":"0.70223","max":"471.90"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":26698,"score":3356}},{"name":"c4.small","price":{"min":"0.0568","max":"38.14"},"ephemeral_read":64,"ephemeral_write":32,"network_average":655360},{"name":"c4.medium","price":{"min":"0.1004","max":"67.50"},"ephemeral_read":128,"ephemeral_write":64,"network_average":655360},{"name":"c4.large","price":{"min":"0.2009","max":"135.00"},"ephemeral_read":256,"ephemeral_write":128,"network_average":655360},{"name":"c4.xlarge","price":{"min":"0.4118","max":"276.75"},"ephemeral_read":512,"ephemeral_write":256,"network_average":655360},{"name":"c4.2xlarge","price":{"min":"0.6328","max":"425.25"},"ephemeral_read":768,"ephemeral_write":384,"network_average":655360},{"name":"c4.4xlarge","price":{"min":"0.8839","max":"594.00"},"ephemeral_read":1024,"ephemeral_write":512,"network_average":655360},{"name":"m2.medium","price":{"min":"0.147321428571","max":"99.00"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":5018,"score":2905}},{"name":"m2.large","price":{"min":"0.294642857143","max":"198.00"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":9167,"score":2901}},{"name":"m2.xlarge","price":{"min":"0.441964285714","max":"297.00"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":13888,"score":2757}},{"name":"m2.2xlarge","price":{"min":"0.589285714286","max":"396.00"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":16941,"score":2746}},{"name":"m2.4xlarge","price":{"min":"0.736607142857","max":"495.00"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":19820,"score":2826}},{"name":"m2.8xlarge","price":{"min":"0.883928571429","max":"594.00"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":22176,"score":2671}},{"name":"m3.medium","price":{"min":"0.1563","max":"105.00"},"ephemeral_read":64,"ephemeral_write":32,"network_average":655360},{"name":"m3.large","price":{"min":"0.3125","max":"210.00"},"ephemeral_read":64,"ephemeral_write":32,"network_average":655360},{"name":"m3.xlarge","price":{"min":"0.4688","max":"315.00"},"ephemeral_read":192,"ephemeral_write":96,"network_average":655360},{"name":"m3.2xlarge","price":{"min":"0.6250","max":"420.00"},"ephemeral_read":256,"ephemeral_write":128,"network_average":655360},{"name":"m3.4xlarge","price":{"min":"0.7813","max":"525.00"},"ephemeral_read":320,"ephemeral_write":160,"network_average":655360},{"name":"m3.8xlarge","price":{"min":"0.9375","max":"630.00"},"ephemeral_read":384,"ephemeral_write":192,"network_average":655360},{"name":"p2.medium","price":{"min":"0.0589","max":"39.60"},"ephemeral_read":200,"ephemeral_write":50,"network_average":655360},{"name":"p2.large","price":{"min":"0.1179","max":"79.20"},"ephemeral_read":200,"ephemeral_write":50,"network_average":655360,"geekbench":{"multicore_score":13749,"score":4003}},{"name":"p2.xlarge","price":{"min":"0.2357","max":"158.40"},"ephemeral_read":200,"ephemeral_write":50,"network_average":655360,"geekbench":{"multicore_score":24221,"score":3966}},{"name":"p2.2xlarge","price":{"min":"0.3536","max":"237.60"},"ephemeral_read":200,"ephemeral_write":50,"network_average":655360,"geekbench":{"multicore_score":30322,"score":4071}},{"name":"p2.4xlarge","price":{"min":"0.4714","max":"316.80"},"ephemeral_read":200,"ephemeral_write":50,"network_average":655360,"geekbench":{"multicore_score":34736,"score":4085}},{"name":"p2.8xlarge","price":{"min":"0.5893","max":"396.00"},"ephemeral_read":200,"ephemeral_write":50,"network_average":655360,"geekbench":{"multicore_score":37182,"score":4105}},{"name":"p2.16xlarge","price":{"min":"0.7071","max":"475.20"},"ephemeral_read":200,"ephemeral_write":50,"network_average":655360,"geekbench":{"multicore_score":43664,"score":4074}},{"name":"p3.medium","price":{"min":"0.0379","max":"25.50"},"ephemeral_read":285,"ephemeral_write":142,"network_average":655360},{"name":"p3.large","price":{"min":"0.0759","max":"51.00"},"ephemeral_read":569,"ephemeral_write":285,"network_average":655360},{"name":"p3.xlarge","price":{"min":"0.1518","max":"102.00"},"ephemeral_read":1138,"ephemeral_write":569,"network_average":655360},{"name":"p3.2xlarge","price":{"min":"0.2277","max":"153.00"},"ephemeral_read":1707,"ephemeral_write":853,"network_average":655360},{"name":"p3.4xlarge","price":{"min":"0.3036","max":"204.00"},"ephemeral_read":2276,"ephemeral_write":1138,"network_average":655360},{"name":"p3.8xlarge","price":{"min":"0.3795","max":"255.00"},"ephemeral_read":2845,"ephemeral_write":1422,"network_average":655360},{"name":"p3.16xlarge","price":{"min":"0.4554","max":"306.00"},"ephemeral_read":3413,"ephemeral_write":1707,"network_average":655360},{"name":"s3.small","price":{"min":"0.024553571429","max":"16.50"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":2636,"score":2645}},{"name":"s3.medium","price":{"min":"0.049107142857","max":"33.00"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":4988,"score":2669}},{"name":"s3.large","price":{"min":"0.098214285714","max":"66.00"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":9615,"score":2813}},{"name":"s3.xlarge","price":{"min":"0.196428571429","max":"132.00"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":16476,"score":2770}},{"name":"s4.small","price":{"min":"0.0268","max":"18.00"},"ephemeral_read":64,"ephemeral_write":32,"network_average":655360},{"name":"s4.medium","price":{"min":"0.0536","max":"36.00"},"ephemeral_read":128,"ephemeral_write":64,"network_average":655360},{"name":"s4.large","price":{"min":"0.1071","max":"72.00"},"ephemeral_read":256,"ephemeral_write":128,"network_average":655360},{"name":"s4.xlarge","price":{"min":"0.2143","max":"144.00"},"ephemeral_read":512,"ephemeral_write":256,"network_average":655360},{"name":"g2.small","price":{"min":"0.82500","max":"554.40"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":19840,"score":3995}},{"name":"g2.medium","price":{"min":"1.37500","max":"924.00"},"ephemeral_read":50,"ephemeral_write":25,"network_average":327680,"geekbench":{"multicore_score":32131,"score":4099}},{"name":"emk1.small","price":{"min":"0.06057","max":"40.70"}},{"name":"emk1.medium","price":{"min":"0.19643","max":"132.00"}},{"name":"emk1.large","price":{"min":"0.33556","max":"225.50"}},{"name":"emk1.xlarge","price":{"min":"0.58111","max":"390.51"}},{"name":"s5.small","price":{"min":0.026042,"max":17.5}},{"name":"s5.medium","price":{"min":0.055804,"max":37.5}},{"name":"s5.large","price":{"min":0.111607,"max":75}},{"name":"s5.xlarge","price":{"min":0.223214,"max":150}},{"name":"s5.2xlarge","price":{"min":0.446429,"max":300}},{"name":"s5.4xlarge","price":{"min":0.892857,"max":600}},{"name":"c5.small","price":{"min":0.032738,"max":22}},{"name":"c5.medium","price":{"min":0.065104,"max":43.75}},{"name":"c5.large","price":{"min":0.130208,"max":87.5}},{"name":"c5.xlarge","price":{"min":0.260417,"max":175}},{"name":"c5.2xlarge","price":{"min":0.520833,"max":350}},{"name":"c5.4xlarge","price":{"min":1.041667,"max":700}},{"name":"m5.small","price":{"min":0.039807,"max":26.75}},{"name":"m5.medium","price":{"min":0.079613,"max":53.5}},{"name":"m5.large","price":{"min":0.187872,"max":126.25}},{"name":"m5.xlarge","price":{"min":0.31622,"max":212.5}},{"name":"m5.2xlarge","price":{"min":0.63244,"max":425}},{"name":"m5.4xlarge","price":{"min":1.264881,"max":850}}]
        data.forEach((item) => {
            this.$store.commit('flavor/UPDATE', item);
        })
    },

    trimObject(obj) {
      if (!Array.isArray(obj) && typeof obj !== 'object') {
        return obj;
      }
      return Object.keys(obj).reduce((acc, key) => {
        if (typeof obj[key] === 'string') {
          acc[key.trim()] = obj[key].trim();
        } else if (obj[key] === null || obj[key] === undefined) {
          // Do nothing
        } else {
          acc[key.trim()] = this.trimObject(obj[key]);
        }
        return acc;
      }, Array.isArray(obj) ? [] : {});
    },

    makeRandomName(length) {
        var result           = '';
        var characters       = 'abcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
       }
       return result;
    },

    async subscribeToEvents() {
      subscribeToEventSource((event) => {
        try {
          event = JSON.parse(event.data);
          if (event.initiator === 'openstack:post') {
              if (event.status === 'Success') {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'environmentCreated'
                });
                this.pollProjectStatus();
              } else if (event.status === 'Failed') {
                    this.setUserData();
                    this.showNotification('error', 'Cloud environment not created');
              }
          } else {
              if (event.status === 'Failed') {
                  this.showNotification('error', event.message);
              } else if (event.status === 'Success') {
                  this.showNotification('success', event.message);
              }
          }
        } catch (error) {
          console.error(error);
        }
      });
    },

    toggleCards(view) {
        localStorage.setItem('show_cards', view);
        this.$store.commit('misc/SHOW_CARDS', view);
    },

    async fetchCurrentMonthUsage(year, month, teamId, otherMonth) {
      if (otherMonth) {
          this.$store.commit('usage/IS_LOADING', true);
      }
      if (!teamId) {
        teamId = localStorage.getItem('current_team_id');
      }
      getResourceUsage(year, month, teamId)
      .then((response) => {
        let data = response.data
        // data = {"id":"5f3950e3-2168-44c5-9ffc-c602b8e5c78d","name":"Marino Dekker","projects":[{"espada_id":"9de9de53-9a5d-4470-87ce-e287d33bd124","name":"ams2 Marino Dekker","os_id":"f8548e9a3e9c4a9f8ae46f927e270909","regions":{"ams2":{"all":{"label":"All usage","quantities":[131729148672,131729148672,131729148672,131729148672,131729148674,131729148672,131729148672,131729148672,131729148672,131729148672,131729148672,131729148712,131729148794,131729148792,131729148792,131729148792,131729148792,131729157202,131729148792,131729148792,131729148792,131729148792,131729148792,131729148792,131729148792,131729148792,131729148792,131739135175,32938406622,0],"total":852.148026903487,"total_after_discount":0,"total_quantity":3721364566195,"values":[28.658035714285713,28.658035714285713,28.658035714285713,28.658035714285713,29.050892857142856,28.658035714285713,28.658035714285713,28.658035714285713,28.658035714285713,28.658035714285713,28.658035714285713,29.504464285714285,31.249404761904763,31.197321428571428,31.197321428571428,31.197321428571428,31.197321428571428,31.197404358586343,31.197321428571428,31.197321428571428,31.197321428571428,31.197321428571428,31.197321428571428,31.197321428571428,31.197321428571428,31.197321428571428,31.197321428571428,31.200012425853114,7.8003125,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},"labels":["2024-11-01","2024-11-02","2024-11-03","2024-11-04","2024-11-05","2024-11-06","2024-11-07","2024-11-08","2024-11-09","2024-11-10","2024-11-11","2024-11-12","2024-11-13","2024-11-14","2024-11-15","2024-11-16","2024-11-17","2024-11-18","2024-11-19","2024-11-20","2024-11-21","2024-11-22","2024-11-23","2024-11-24","2024-11-25","2024-11-26","2024-11-27","2024-11-28","2024-11-29","2024-11-30"],"meta":{},"usage":{"compute":[{"label":"image-test","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":22.196428571428573,"total_after_discount":0,"total_quantity":678,"values":[0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.7857142857142858,0.19642857142857145,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"shoot--7ys6shw--test-worker-edjia-1-z2-74fcd-fsm5k","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":133.1785714285714,"total_after_discount":0,"total_quantity":678,"values":[4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,1.1785714285714286,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"shoot--7ys6shw--test-worker-edjia-1-z1-89f95-bnpzz","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":133.1785714285714,"total_after_discount":0,"total_quantity":678,"values":[4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,4.714285714285714,1.1785714285714286,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"shoot--7ys6shw--test-worker-edjia-1-z1-89f95-tvnkw","quantities":[0,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"total":0.39285714285714285,"total_after_discount":0,"total_quantity":2,"values":[0,0,0,0,0.39285714285714285,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"shoot--7ys6shw--testpools-worker-azdml-1-z1-7d749-4pcpq","quantities":[0,0,0,0,0,0,0,0,0,0,0,8,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":10.364583333333334,"total_after_discount":0,"total_quantity":398,"values":[0,0,0,0,0,0,0,0,0,0,0,0.20833333333333334,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.15625,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"shoot--7ys6shw--testpools-worker-azdml-2-z2-cb4cc-9plnh","quantities":[0,0,0,0,0,0,0,0,0,0,0,8,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"total":0.46875,"total_after_discount":0,"total_quantity":18,"values":[0,0,0,0,0,0,0,0,0,0,0,0.20833333333333334,0.2604166666666667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"shoot--7ys6shw--testpools-worker-azdml-2-z1-6f994-dfq6j","quantities":[0,0,0,0,0,0,0,0,0,0,0,8,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"total":0.46875,"total_after_discount":0,"total_quantity":18,"values":[0,0,0,0,0,0,0,0,0,0,0,0.20833333333333334,0.2604166666666667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"shoot--7ys6shw--testpools-worker-azdml-1-z2-85989-zjg9l","quantities":[0,0,0,0,0,0,0,0,0,0,0,8,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":10.364583333333334,"total_after_discount":0,"total_quantity":398,"values":[0,0,0,0,0,0,0,0,0,0,0,0.20833333333333334,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.15625,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"shoot--7ys6shw--testpools-worker-azdml-2-z1-68fd5-lc8nl","quantities":[0,0,0,0,0,0,0,0,0,0,0,0,15,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":9.921875,"total_after_discount":0,"total_quantity":381,"values":[0,0,0,0,0,0,0,0,0,0,0,0,0.390625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.15625,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"shoot--7ys6shw--testpools-worker-azdml-2-z2-b75d4-schmv","quantities":[0,0,0,0,0,0,0,0,0,0,0,0,15,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":9.921875,"total_after_discount":0,"total_quantity":381,"values":[0,0,0,0,0,0,0,0,0,0,0,0,0.390625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.625,0.15625,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}],"network":[{"label":"ip address","quantities":[312,312,312,312,312,312,312,312,312,312,312,320,336,336,336,336,336,336,336,336,336,336,336,336,336,336,336,336,84,0],"total":15.07916666666667,"total_after_discount":0,"total_quantity":9212,"values":[0.5107142857142857,0.5107142857142857,0.5107142857142857,0.5107142857142857,0.5107142857142857,0.5107142857142857,0.5107142857142857,0.5107142857142857,0.5107142857142857,0.5107142857142857,0.5107142857142857,0.5238095238095238,0.55,0.55,0.55,0.55,0.55,0.55,0.55,0.55,0.55,0.55,0.55,0.55,0.55,0.55,0.55,0.55,0.1375,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"loadbalancer","quantities":[48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,12,0],"total":83.12562499999999,"total_after_discount":0,"total_quantity":1356,"values":[2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,2.9425000000000003,0.7356250000000001,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}],"storage":[{"label":"objectstore bucket usage bytes","quantities":[6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6492979200,6501838848,1629364224,0],"total":0.16876488095238093,"total_after_discount":0,"total_quantity":183441641472,"values":[0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.005892857142857142,0.007202380952380952,0.002455357142857143,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"force-incremental","quantities":[240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,60,0],"total":0.8071428571428572,"total_after_discount":0,"total_quantity":6780,"values":[0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.0071428571428571435,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"regggererg","quantities":[480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,120,0],"total":1.6142857142857143,"total_after_discount":0,"total_quantity":13560,"values":[0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.014285714285714287,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"volume bu","quantities":[240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,60,0],"total":0.8071428571428572,"total_after_discount":0,"total_quantity":6780,"values":[0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.028571428571428574,0.0071428571428571435,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"volume","quantities":[5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,5760,1440,0],"total":57.40803571428572,"total_after_discount":0,"total_quantity":162720,"values":[2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,2.032142857142857,0.5080357142857143,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"snap-vol","quantities":[4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,4848,1212,0],"total":50.950892857142854,"total_after_discount":0,"total_quantity":136956,"values":[1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,1.8035714285714284,0.4508928571428571,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"img-vol","quantities":[2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,2520,630,0],"total":26.484375,"total_after_discount":0,"total_quantity":71190,"values":[0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.9375,0.234375,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"back-volume","quantities":[480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,120,0],"total":5.044642857142857,"total_after_discount":0,"total_quantity":13560,"values":[0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.04464285714285714,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"nog-een","quantities":[240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,60,0],"total":2.5223214285714284,"total_after_discount":0,"total_quantity":6780,"values":[0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.02232142857142857,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"andere-naam-2","quantities":[3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,3264,816,0],"total":34.30357142857144,"total_after_discount":0,"total_quantity":92208,"values":[1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,1.2142857142857144,0.3035714285714286,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"restor-vol-snap","quantities":[2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,600,0],"total":25.22321428571428,"total_after_discount":0,"total_quantity":67800,"values":[0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.2232142857142857,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"test","quantities":[16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,16800,4200,0],"total":176.5625,"total_after_discount":0,"total_quantity":474600,"values":[6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,6.25,1.5625,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"im-vol","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":0.25223214285714285,"total_after_discount":0,"total_quantity":678,"values":[0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.002232142857142857,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"restore-bg","quantities":[2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,600,0],"total":25.22321428571428,"total_after_discount":0,"total_quantity":67800,"values":[0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.2232142857142857,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"back-vol","quantities":[480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,120,0],"total":5.044642857142857,"total_after_discount":0,"total_quantity":13560,"values":[0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.04464285714285714,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"image-vol","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":0.25223214285714285,"total_after_discount":0,"total_quantity":678,"values":[0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.008928571428571428,0.002232142857142857,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"vol-from-back","quantities":[960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,240,0],"total":10.089285714285714,"total_after_discount":0,"total_quantity":27120,"values":[0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.08928571428571427,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"qwdqwwdq","quantities":[1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,1156872,289218,0],"total":0.08071428571428574,"total_after_discount":0,"total_quantity":32681634,"values":[0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.0007142857142857143,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"dsfsdfsdf","quantities":[13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,3313330230,0],"total":0.08071428571428574,"total_after_discount":0,"total_quantity":374406315990,"values":[0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.0007142857142857143,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"qqqq","quantities":[61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,61849731120,15462432780,0],"total":0.24214285714285713,"total_after_discount":0,"total_quantity":1747254904140,"values":[0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.008571428571428572,0.002142857142857143,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"eph-backup","quantities":[36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,36792434640,9198108660,0],"total":0.16142857142857148,"total_after_discount":0,"total_quantity":1039386278580,"values":[0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.005714285714285714,0.0014285714285714286,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"sdafsdf","quantities":[13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,13253320920,3313330230,0],"total":0.08071428571428574,"total_after_discount":0,"total_quantity":374406315990,"values":[0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.0007142857142857143,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"ewrwerewr","quantities":[86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,86163408,21540852,0],"total":0.08071428571428574,"total_after_discount":0,"total_quantity":2434116276,"values":[0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.0007142857142857143,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"objectstore bucket traffic egress bytes","quantities":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8395,0,0,0,0,0,0,0,0,0,109199,0,0],"total":0.000006023487076163292,"total_after_discount":0,"total_quantity":117594,"values":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4.3001491576433184e-7,0,0,0,0,0,0,0,0,0,0.00000559347216039896,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"objectstore bucket operations class a total","quantities":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15,0,0,0,0,0,0,0,0,0,250,0,0],"total":0.0014575,"total_after_discount":0,"total_quantity":265,"values":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.0000825,0,0,0,0,0,0,0,0,0,0.001375,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"objectstore bucket operations class b total","quantities":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,0],"total":8.8e-7,"total_after_discount":0,"total_quantity":2,"values":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8.8e-7,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"objectstore bucket traffic ingress bytes","quantities":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1017284,0,0],"total":0,"total_after_discount":0,"total_quantity":1017284,"values":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}]}},"fra":{"all":{"label":"All usage","quantities":[274485273192,274485273192,274485273192,267009688172,274485273192,274485273192,274485273192,274485273192,274485273192,274485273192,274485273192,274485273192,274485273150,274485273120,274485273120,274485273120,274485273120,274485273120,274485273120,274485273120,274485273120,274485273120,274485273120,274485273120,274485273120,274485273120,274485273120,274500596774,68622375048,0],"total":289.2325878632021,"total_after_discount":0,"total_quantity":7746749761936,"values":[10.304285714285713,10.304285714285713,10.304285714285713,10.303549107142857,10.304285714285713,10.304285714285713,10.304285714285713,10.304285714285713,10.304285714285713,10.304285714285713,10.304285714285713,10.304285714285713,10.235535714285714,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.186428571428571,10.18926197034499,2.547098214285714,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},"labels":["2024-11-01","2024-11-02","2024-11-03","2024-11-04","2024-11-05","2024-11-06","2024-11-07","2024-11-08","2024-11-09","2024-11-10","2024-11-11","2024-11-12","2024-11-13","2024-11-14","2024-11-15","2024-11-16","2024-11-17","2024-11-18","2024-11-19","2024-11-20","2024-11-21","2024-11-22","2024-11-23","2024-11-24","2024-11-25","2024-11-26","2024-11-27","2024-11-28","2024-11-29","2024-11-30"],"meta":{},"usage":{"compute":[{"label":"shoot--7ys6shw--fra-worker-evy62-1-z2-75f58-2tr99","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":41.06339285714286,"total_after_discount":0,"total_quantity":678,"values":[1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,0.36339285714285713,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"ubuntu-t4-1vcpu-10gb","quantities":[48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,12,0],"total":7.324821428571428,"total_after_discount":0,"total_quantity":1356,"values":[0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.2592857142857143,0.06482142857142857,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"new-boot-disk-t4-1vcpu-10gb","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":3.662410714285714,"total_after_discount":0,"total_quantity":678,"values":[0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.032410714285714286,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"shoot--7ys6shw--fra-worker-evy62-1-z1-7cdfb-8qhs4","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":41.06339285714286,"total_after_discount":0,"total_quantity":678,"values":[1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,1.4535714285714285,0.36339285714285713,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"nieuw-gecreeerd","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":3.662410714285714,"total_after_discount":0,"total_quantity":678,"values":[0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.032410714285714286,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"Ubuntu 22-04 Jammy-t4-1vcpu-10gb","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":3.662410714285714,"total_after_discount":0,"total_quantity":678,"values":[0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.12964285714285714,0.032410714285714286,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}],"network":[{"label":"ip address","quantities":[288,288,288,288,288,288,288,288,288,288,288,288,246,216,216,216,216,216,216,216,216,216,216,216,216,216,216,216,54,0],"total":11.451785714285712,"total_after_discount":0,"total_quantity":6996,"values":[0.4714285714285714,0.4714285714285714,0.4714285714285714,0.4714285714285714,0.4714285714285714,0.4714285714285714,0.4714285714285714,0.4714285714285714,0.4714285714285714,0.4714285714285714,0.4714285714285714,0.4714285714285714,0.40267857142857144,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.3535714285714286,0.08839285714285715,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"loadbalancer","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":27.690044642857142,"total_after_discount":0,"total_quantity":678,"values":[0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.9801785714285716,0.2450446428571429,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}],"storage":[{"label":"objectstore bucket usage bytes","quantities":[179414040480,179414040480,179414040480,171938455460,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179414040480,179415412640,44854566888,0],"total":0.4999107142857142,"total_after_discount":0,"total_quantity":5060973487468,"values":[0.017678571428571425,0.01767857142857143,0.017678571428571425,0.016941964285714286,0.017678571428571425,0.017678571428571425,0.01767857142857143,0.017678571428571425,0.01767857142857143,0.01767857142857143,0.017678571428571425,0.01767857142857143,0.01767857142857143,0.01767857142857143,0.017678571428571425,0.017678571428571425,0.017678571428571425,0.017678571428571425,0.017678571428571425,0.01767857142857143,0.01767857142857143,0.01767857142857143,0.017678571428571425,0.017678571428571425,0.017678571428571425,0.01767857142857143,0.017678571428571425,0.01841517857142857,0.004910714285714286,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"ciros resource","quantities":[240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,240,60,0],"total":2.5223214285714284,"total_after_discount":0,"total_quantity":6780,"values":[0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.08928571428571427,0.02232142857142857,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"new-boot-disk","quantities":[2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,2400,600,0],"total":25.22321428571428,"total_after_discount":0,"total_quantity":67800,"values":[0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.8928571428571428,0.2232142857142857,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"volu-from-fra-snapshot","quantities":[480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,120,0],"total":5.044642857142857,"total_after_discount":0,"total_quantity":13560,"values":[0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.04464285714285714,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"volume","quantities":[960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,960,240,0],"total":10.089285714285714,"total_after_discount":0,"total_quantity":27120,"values":[0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.3571428571428571,0.08928571428571427,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"backuped fra new volume","quantities":[5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,5592,1398,0],"total":58.7700892857143,"total_after_discount":0,"total_quantity":157974,"values":[2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,2.080357142857143,0.5200892857142857,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"volume-from-snap","quantities":[480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,120,0],"total":5.044642857142857,"total_after_discount":0,"total_quantity":13560,"values":[0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.17857142857142855,0.04464285714285714,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"snapshot fra1111","quantities":[480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,120,0],"total":1.6142857142857143,"total_after_discount":0,"total_quantity":13560,"values":[0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.014285714285714287,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"snapshot fra","quantities":[480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,120,0],"total":1.6142857142857143,"total_after_discount":0,"total_quantity":13560,"values":[0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.014285714285714287,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"fsdfdsfsddfsds-weg","quantities":[5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,1380,0],"total":18.56428571428572,"total_after_discount":0,"total_quantity":155940,"values":[0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.16428571428571428,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"backup of nieuw-volume fra","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":0.08071428571428574,"total_after_discount":0,"total_quantity":678,"values":[0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.0007142857142857143,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"fra backup tets","quantities":[480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,480,120,0],"total":1.6142857142857143,"total_after_discount":0,"total_quantity":13560,"values":[0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.05714285714285715,0.014285714285714287,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"new backup","quantities":[5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,5520,1380,0],"total":18.56428571428572,"total_after_discount":0,"total_quantity":155940,"values":[0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.6571428571428571,0.16428571428571428,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"blaidiediadiiadiaiaiaaiaia","quantities":[95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,95070191520,23767547880,0],"total":0.32285714285714295,"total_after_discount":0,"total_quantity":2685732910440,"values":[0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.011428571428571429,0.002857142857142857,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"rtgrtgrtgr","quantities":[1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,1018056,254514,0],"total":0.08071428571428574,"total_after_discount":0,"total_quantity":28760082,"values":[0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.002857142857142857,0.0007142857142857143,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"objectstore bucket operations class a total","quantities":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,252,0,0],"total":0.001386,"total_after_discount":0,"total_quantity":252,"values":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.001386,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"objectstore bucket traffic egress bytes","quantities":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13781999,0,0],"total":0.0007059517735615373,"total_after_discount":0,"total_quantity":13781999,"values":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.0007059517735615373,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"objectstore bucket operations class b total","quantities":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0],"total":0.00000484,"total_after_discount":0,"total_quantity":11,"values":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.00000484,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"objectstore bucket traffic ingress bytes","quantities":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,169232,0,0],"total":0,"total_after_discount":0,"total_quantity":169232,"values":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}]}}}},{"espada_id":"d781a0af-64ff-4bf5-9847-403349542ca2","name":"marino-tweede-project-renamed","os_id":"744613d8e89b4e2f8f986ea9f32c6b3b","regions":{"ams2":{"labels":["2024-11-01","2024-11-02","2024-11-03","2024-11-04","2024-11-05","2024-11-06","2024-11-07","2024-11-08","2024-11-09","2024-11-10","2024-11-11","2024-11-12","2024-11-13","2024-11-14","2024-11-15","2024-11-16","2024-11-17","2024-11-18","2024-11-19","2024-11-20","2024-11-21","2024-11-22","2024-11-23","2024-11-24","2024-11-25","2024-11-26","2024-11-27","2024-11-28","2024-11-29","2024-11-30"],"meta":{},"usage":{}},"fra":{"labels":["2024-11-01","2024-11-02","2024-11-03","2024-11-04","2024-11-05","2024-11-06","2024-11-07","2024-11-08","2024-11-09","2024-11-10","2024-11-11","2024-11-12","2024-11-13","2024-11-14","2024-11-15","2024-11-16","2024-11-17","2024-11-18","2024-11-19","2024-11-20","2024-11-21","2024-11-22","2024-11-23","2024-11-24","2024-11-25","2024-11-26","2024-11-27","2024-11-28","2024-11-29","2024-11-30"],"meta":{},"usage":{}}}}],"team":{"all":{"label":"All usage","quantities":[192,192,192,192,192,192,192,192,192,192,192,200,160,120,120,120,120,120,120,120,120,120,120,120,120,120,120,120,30,0],"total":235.56092504,"total_after_discount":0,"total_quantity":4302,"values":[10.71142608,10.71142608,10.71142608,10.711426079999999,10.71142608,10.71142608,10.71142608,10.711426079999999,10.71142608,10.711426079999999,10.71142608,11.06844976,8.65833118,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,6.42678408,1.60669602,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},"labels":["2024-11-01","2024-11-02","2024-11-03","2024-11-04","2024-11-05","2024-11-06","2024-11-07","2024-11-08","2024-11-09","2024-11-10","2024-11-11","2024-11-12","2024-11-13","2024-11-14","2024-11-15","2024-11-16","2024-11-17","2024-11-18","2024-11-19","2024-11-20","2024-11-21","2024-11-22","2024-11-23","2024-11-24","2024-11-25","2024-11-26","2024-11-27","2024-11-28","2024-11-29","2024-11-30"],"meta":{},"usage":{"managed_services":[{"label":"test","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":30.257756880000002,"total_after_discount":0,"total_quantity":678,"values":[1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,0.26776776,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"static-token","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"total":13.299132080000001,"total_after_discount":0,"total_quantity":298,"values":[1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,0.4462796,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"fra-cluster","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"total":13.299132080000001,"total_after_discount":0,"total_quantity":298,"values":[1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,0.4462796,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"ha-cluster","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":60.52562273999999,"total_after_discount":0,"total_quantity":678,"values":[2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,0.5356249799999999,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"emk-new-dash","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":30.257756880000002,"total_after_discount":0,"total_quantity":678,"values":[1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,0.26776776,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"fra","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":30.257756880000002,"total_after_discount":0,"total_quantity":678,"values":[1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,0.26776776,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"wrkrlss-dshb","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"total":13.299132080000001,"total_after_discount":0,"total_quantity":298,"values":[1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,0.4462796,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"new1","quantities":[24,24,24,24,24,24,24,24,24,24,24,24,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"total":26.602707339999995,"total_after_discount":0,"total_quantity":298,"values":[2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,2.1424999199999997,0.8927083,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{"label":"testpools","quantities":[0,0,0,0,0,0,0,0,0,0,0,8,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,6,0],"total":17.76192808,"total_after_discount":0,"total_quantity":398,"values":[0,0,0,0,0,0,0,0,0,0,0,0.35702368,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,1.07107104,0.26776776,0],"values_after_discount":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}]}}}
          let totalUsage = []
          totalUsage.total = {};
          totalUsage.total.total = 0;
          totalUsage.total.total_after_discount = 0;
          data.projects.forEach((dataPerProject) => {
            for (const [regionName, projectRegionData] of Object.entries(dataPerProject.regions)) {
                if (projectRegionData.all) {
                    totalUsage.total.total += projectRegionData.all.total;
                    totalUsage.total.total_after_discount += projectRegionData.all.total_after_discount;
                }
                let projectData  = []
                projectData.project = dataPerProject.name;
                projectData.total = 0;
                projectData.labels = projectRegionData.labels;
                projectData.resources = projectRegionData.usage;
                projectData.region = regionName;

                if (projectData.resources) {
                  for (const [service, serviceData] of Object.entries(projectData.resources)) {
                      projectData.total += serviceData[0].total;
                  };
                }
                totalUsage.push(projectData);
            }
          })

          if (data.team.all) {
            let teamData = {}
            teamData.team = data.name;
            teamData.resources = data.team.usage;
            teamData.labels = data.team.labels;
            totalUsage.team_services = [];
            totalUsage.team_services = teamData;

            totalUsage.total.total += data.team.all.total;
            totalUsage.total.total_after_discount += data.team.all.total_after_discount;
          }

          if (otherMonth) {
              this.$store.dispatch('usage/UPDATE_SELECTED_MONTH', totalUsage);
              this.$store.commit('usage/UPDATE_KEY');
              this.$store.commit('usage/IS_LOADING', false);
          } else {
              this.$store.dispatch('usage/UPDATE_CURRENT_MONTH', totalUsage);
              this.$store.commit('usage/HAS_DATA', true);
          }
      })
      .catch((error) => {
          console.error(error);
          this.showNotification('error', 'Fetching your usage data has failed');
          this.$store.commit('usage/HAS_DATA', false);
          this.$store.commit('usage/HAS_ERROR', true);
      });
    },

    toggleModalElement(elementsArray, elementToShow) {
      // The `elementsArray` and `elementToShow` parameters
      // only work with mutation names. Fire mutations which toggle visibility
      // of certain elements.
      const elementsArrayWithoutElementToShow = elementsArray.filter((element) => {
        return element !== elementToShow;
      });

      elementsArrayWithoutElementToShow.forEach((element) => {
        this.$store.commit(`form/${element}`, false);
      });

      this.$store.commit(`form/${elementToShow}`, true);
    },

    hibernationConverter(value) {
        if (value) {
            if (value[0] && value[0].selectedWeekdays && value[0].selectedWeekdays.length > 0) {
                return value;
            } else if (value[0] && value[0].selectedWeekdays && value[0].selectedWeekdays.length === 0) {
                return false;
            } else {
                let data = [];
                value.forEach((item) => {
                    if (!item.selectedWeekdays) {
                        let hibernationItem = {};
                        if (item.start !== undefined) {
                            let startTime = item.start.split(' * * ')[0].split(' ');
                            startTime = startTime[0] + ':' + startTime[1];
                            let selectedWeekdays = item.start.split(' * * ')[1];
                            hibernationItem.hibernateAt =  startTime.split(':')[1] + ':' + startTime.split(':')[0];
                            hibernationItem.selectedWeekdays = this.convertStringToNumber(selectedWeekdays.split(','));
                        }
                        if (item.end !== undefined) {
                            let endTime = item.end.split(' * * ')[0].split(' ');
                            endTime = endTime[0] + ':' + endTime[1];
                            let selectedWeekdays = item.end.split(' * * ')[1];
                            hibernationItem.hibernateWakeUp = endTime.split(':')[1] + ':' + endTime.split(':')[0];
                            hibernationItem.selectedWeekdays = this.convertStringToNumber(selectedWeekdays.split(','));
                        }
                        let weekDays = '';
                        if (item.start !== undefined) {
                            weekDays = item.start.split(' * * ')[1];
                        }
                        hibernationItem.location = item.location;
                        data.push(hibernationItem)
                    }
                });
                return data;
            }
        }
    },

    makeSubmitableHibernationData(schedules) {
        let data = [];
        schedules.forEach((schedule, index) => {
            if (schedule.selectedWeekdays.length > 0) {
                let scheduleData = {};
                let weekString = JSON.stringify(schedule.selectedWeekdays);
                if (schedule.hibernateAt || schedule.hibernateWakeUp) {
                    scheduleData.location = schedule.location;
                    if (schedule.hibernateAt) {
                        let startScheduleArray = schedule.hibernateAt.split(':');
                        let scheduleStartString = startScheduleArray[1] + ' ' + startScheduleArray[0] + ' * * ' + weekString.substring(1, weekString.length-1);
                        scheduleData.start = scheduleStartString;
                    }
                    if (schedule.hibernateWakeUp) {
                        let endScheduleArray = schedule.hibernateWakeUp.split(':');
                        let scheduleEndString = endScheduleArray[1] + ' ' + endScheduleArray[0] + ' * * ' + weekString.substring(1, weekString.length-1);
                        scheduleData.end = scheduleEndString;
                    }
                    data.push(scheduleData);
                }
            }
        })
        return data;
    },

    randomString(length) {
      let bytes = new Uint8Array(length);
      let random = window.crypto.getRandomValues(bytes);
      let result = [];
      let charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz';
      random.forEach(function (c) {
        result.push(charset[c % charset.length]);
      });
      return result.join('');
    },

    convertStringToNumber(array) {
        let data = [];
        array.forEach((item, i) => {
              data.push(parseInt(item));
        });
        return data;
    },

    showMaintenanceModal(currentCluster) {
        if (currentCluster) {
            this.$store.commit('emk/SET_CURRENT', currentCluster);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_MAINTENANCE_EMK');
    },

    showPoolsModal(currentCluster) {
        if (currentCluster) {
            this.$store.commit('emk/SET_CURRENT', currentCluster);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_POOLS_EMK');
    },

    showAddonsModal(currentCluster) {
        if (currentCluster) {
            this.$store.commit('emk/SET_CURRENT', currentCluster);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_ADDONS_EMK');
    },

    showRefreshCredentials(credData) {
        this.$store.commit('emk/SET_ROTATION', credData);
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_CREDENTIALS_EMK');
    },

    showDnsEmkModal(currentCluster) {
        if (currentCluster) {
            this.$store.commit('emk/SET_CURRENT', currentCluster);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_DNS_EMK');
    },

    showHAEmkModal(currentCluster) {
      if (currentCluster) {
          this.$store.commit('emk/SET_CURRENT', currentCluster);
      }
      this.$store.commit('emk/UPDATE_KEY_FORM');
      this.emkModal('SHOW_FORM_HA_EMK');
    },

    showEmkServiceAccountModal(currentAccount, modalName) {
        if (currentAccount) {
            this.$store.commit('emk/SET_CURRENT_ACCOUNT', currentAccount);
        } else {
            this.$store.commit('emk/SET_CURRENT_ACCOUNT', false);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        if (modalName === 'deleteServiceAccount') {
            this.emkModal('SHOW_FORM_DELETE_SERVICE_ACCOUNT');
        } else if (modalName === 'resetServiceAccount') {
          this.emkModal('SHOW_FORM_RESET_SERVICE_ACCOUNT');
        } else {
          this.emkModal('SHOW_FORM_CREATE_SERVICE_ACCOUNT');
        }
    },

    showHibernationModal(currentCluster) {
        if (currentCluster) {
            this.$store.commit('emk/SET_CURRENT', currentCluster);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_HIBERNATION_EMK');
    },

    showDirectHibernationModal(currentCluster) {
        if (currentCluster) {
            this.$store.commit('emk/SET_CURRENT', currentCluster);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_DIRECT_HIBERNATION_EMK');
    },

    showReconcileModal(currentCluster) {
        if (currentCluster) {
            this.$store.commit('emk/SET_CURRENT', currentCluster);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_RECONCILE_EMK');
    },

    showRotateKubeConfigModal(currentCluster) {
        if (currentCluster) {
            this.$store.commit('emk/SET_CURRENT', currentCluster);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_ROTATE_KUBECONFIG_EMK');
    },

    deleteEmkClusterModal(currentCluster) {
        if (currentCluster) {
            this.$store.commit('emk/SET_CURRENT', currentCluster);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_DELETE_EMK');
    },

    showEmkAccessModal(currentCluster, serviceAccount, limitedAccess) {
        if (currentCluster) {
            this.$store.commit('emk/SET_CURRENT_ACCOUNT', false);
            if (limitedAccess) {
              currentCluster.limitedAccess = true;
            } else {
              currentCluster.limitedAccess = false;
            }
            this.$store.commit('emk/SET_CURRENT', currentCluster);
        }
        if (serviceAccount) {
            this.$store.commit('emk/SET_CURRENT', false);
            this.$store.commit('emk/SET_CURRENT_ACCOUNT', serviceAccount);
        }
        this.$store.commit('emk/UPDATE_KEY_FORM');
        this.emkModal('SHOW_FORM_ACCESS_EMK');
    },

    // showModalCreateNameSpace(currentCluster) {
    //     if (currentCluster) {
    //         this.$store.commit('emk/SET_CURRENT', currentCluster);
    //     }
    //     this.$store.commit('emk/UPDATE_KEY_FORM');
    //     this.emkModal('SHOW_FORM_ACCESS_EMK');
    // },

    addHibernate() {
        if (this.activeCluster.spec.hibernation && this.activeCluster.spec.hibernation.schedules) {
            let checkEmpty = this.activeCluster.spec.hibernation.schedules.filter(pool => pool.name === null)
            if (checkEmpty.length >= 1 && this.activeCluster.spec.hibernation.schedules.length > 0) {
                return
            }
            let number = this.activeCluster.spec.hibernation.schedules.length + 1;
        } else {
            this.activeCluster.spec.hibernation.schedules = []
        }

        this.activeCluster.spec.hibernation.schedules.push({
            hibernateWakeUp: '',
            hibernateAt: '17:00',
            selectedWeekdays: [],
            location: 'Europe/Amsterdam',
        })
        return this.activeCluster.spec.hibernation.schedules;
    },

    convertHibernationDataToJson(hibernationData) {
        let data = [];
        hibernationData.forEach((schedule, index) => {
          let scheduleData = {}
            if (schedule.start) {
                let splittedStartData = schedule.start.split(" ");
                scheduleData.hibernateAt = splittedStartData[1]+':'+splittedStartData[0];
            }
            if (schedule.end) {
                let splittedEndData = schedule.end.split(" ");
                scheduleData.hibernateWakeUp = splittedEndData[1]+':'+splittedEndData[0];
            }
            scheduleData.location = schedule.location;
            let weekdayArrayWithStrings = schedule.start.split(" * * ")[1].split(',');
            scheduleData.selectedWeekdays = weekdayArrayWithStrings.map(str => {
              return Number(str);
            });

            data.push(scheduleData)
        })
        return data;
    },

    convertMaintenanceData(maintenanceData) {
        let data = {}
        data.timeWindow = {}
        data.autoUpdate = {}
        data.timeWindow.begin =  this.convertTime(maintenanceData.updateTime) + maintenanceData.updateTimeZone.split(':')[0] + maintenanceData.updateTimeZone.split(':')[1];
        data.timeWindow.end =  this.convertTime(maintenanceData.updateTimeEnd) + maintenanceData.updateTimeZone.split(':')[0] + maintenanceData.updateTimeZone.split(':')[1];
        data.autoUpdate.machineImageVersion =  maintenanceData.osUpdate;
        data.autoUpdate.kubernetesVersion =  maintenanceData.kubePatchUpdate;
        return data;
    },

    convertMaintenanceDataToJson(maintenanceData) {
        let data = {}
        let beginTime = maintenanceData.timeWindow.begin.slice(0, 4);
        let updateTime = maintenanceData.timeWindow.begin.slice(6, 11);
        data.updateTime = beginTime[0]+beginTime[1]+':'+beginTime[2]+beginTime[3]
        data.updateTimeZone = updateTime[0]+updateTime[1]+updateTime[2]+':'+updateTime[3]+updateTime[4]
        data.osUpdate = maintenanceData.autoUpdate.machineImageVersion;
        data.kubePatchUpdate = maintenanceData.autoUpdate.kubernetesVersion;
        return data;
    },

    convertTime(data, endTime) {
        data = data.split(':');
        let time = '';
        if (endTime) {
            time = String(Number(data[0])+1);
            if (time === '24') {
               time = '00';
            }
        } else {
            time = data[0];
        }
        if (time.length === 1) {
            time = '0'+ time;
        }
        time += data[1] + '00';
        return time;
    },

    addActiveClass(checked) {
        if(event.target.checked) {
            this.$refs[checked][0].classList.add('selected__active');
        } else {
            this.$refs[checked][0].classList.remove('selected__active');
        }
    },

    selectAllItems() {
        let items = this.$el.querySelectorAll('.select__list > li');
        items.forEach((item) => {
            item.classList.add('selected__active');
        });
    },

    deselectAllItems(store) {
      let items = this.$el.querySelectorAll('.select__list > li');
      items.forEach((item) => {
          item.classList.remove('selected__active');
      });
      let patchStore = store + '/SET_SELECTED';
      this.$store.dispatch(patchStore, []);
    },

    showTeamModal(modal) {
        let formsArray = [
            'SHOW_FORM_CREATE_TEAM',
            'SHOW_FORM_EDIT_TEAM',
            'SHOW_FORM_CREATE_PROJECT',
            'SHOW_FORM_EDIT_PROJECT',
            'SHOW_SELECTED_TEAM',
            'SHOW_FORM_INVITE_USER',
            'SHOW_FORM_CHANGE_TEAM_OWNER',
            'SHOW_FORM_DELETE_TEAM_USER',
            'SHOW_PROJECT_TOKEN',
        ];
        this.$store.commit('team/UPDATE_KEY_FORM');
        this.toggleModalElement(formsArray, modal);
        this.$root.$emit('bv::show::modal','team-modal');
    },

    showCustomerModal(modal) {
        let formsArray = [
            'SHOW_FORM_EDIT_CUSTOMER',
        ];
        this.toggleModalElement(formsArray, modal);
        this.$root.$emit('bv::show::modal','customer-modal');
    },

    notificationModal() {
        this.$root.$emit('bv::show::modal','notification-modal');
    },

    showDeleteModal(currentResource, storeName) {
        if (storeName === 'emkSecret') {
            this.$store.commit('emk/SET_CURRENT_SECRET', currentResource);
        } else if (storeName === 'volumeBackup') {
          this.$store.commit('volumev3/SET_CURRENT_VOLUME_BACKUP', currentResource);
        } else {
            this.$store.commit(storeName + '/SET_CURRENT', currentResource);
        }
        this.$store.commit('form/SET_CURRENT_STORENAME', storeName);
        this.$store.commit('form/UPDATE_KEY');
        this.osModal('SHOW_FORM_DELETE');
    },

    osModal(showModal) {
      let formsArray = [
        'SHOW_FORM_DELETE',
        'SHOW_FORM_CREATE_CONTAINER',
        'SHOW_FORM_EDIT_CONTAINER',
        'SHOW_FORM_CREATE_VOLUME',
        'SHOW_FORM_ACCEPT_TRANSFER_VOLUME',
        'SHOW_FORM_CREATE_VOLUME_SNAPSHOT',
        'SHOW_FORM_BOOTABLE_VOLUME',
        'SHOW_VOLUME_SNAPSHOT',
        'SHOW_FORM_CREATE_VOLUME_BACKUP',
        'SHOW_FORM_EDIT_VOLUME',
        'SHOW_VOLUME_TRANSFER_DATA',
        'SHOW_FORM_CREATE_LOAD_BALANCER',
        'SHOW_FORM_DELETE_LOAD_BALANCER',
        'SHOW_FORM_EDIT_LOAD_BALANCER',
        'SHOW_FORM_BYOIP',
        'SHOW_FORM_ASSOCIATE_IP',
        'SHOW_FORM_ALLOCATE_IP',
        'SHOW_FORM_CREATE_SECURITY_GROUP',
        'SHOW_FORM_CREATE_SG_RULE',
        'SHOW_FORM_CREATE_NETWORK',
        'SHOW_FORM_CREATE_SUBNET',
        'SHOW_FORM_SHOW_SUBNET',
        'SHOW_FORM_CREATE_PORT',
        'SHOW_FORM_EDIT_SUBNET',
        'SHOW_FORM_CREATE_ROUTER',
        'SHOW_FORM_CREATE_KEYPAIR',
        'SHOW_FORM_CREATE_SECRET',
        'SHOW_FORM_UPLOAD_PUBLIC_KEY',
        'SHOW_FORM_CREATE_FOLDER',
        'SHOW_FORM_CREATE_APP_CREDENTIAL',
        'SHOW_FORM_RESIZE_INSTANCE',
        'SHOW_FORM_ADD_VOLUME',
        'SHOW_FORM_ADD_SG',
        'SHOW_FORM_ATTACH_INTERFACE',
        'SHOW_INSTANCE_MODAL',
        'SHOW_FORM_DELETE_INSTANCE',
        'SHOW_FORM_ADD_INTERFACE',
        'SHOW_FORM_DETACH_INTERFACE_ROUTER',
        'SHOW_FORM_DETACH_INTERFACE',
        'SHOW_FORM_VOLUME_UPLOAD_IMAGE',
        'SHOW_VOLUME_MODAL',
        'SHOW_FORM_ADD_VOLUME_TO_INSTANCE',
        'SHOW_FORM_REMOVE_VOLUME_TO_INSTANCE',
        'SHOW_FORM_RESTORE_VOLUME_BACKUP',
        'SHOW_FORM_RESIZE_VOLUME',
        'SHOW_FORM_CREATE_IMAGE',
        'SHOW_FORM_CREATE_DNS_ZONE',
        'SHOW_FORM_CREATE_DNS_RECORD',
        'SHOW_FORM_CREATE_DATABASE_BACKUP',
        'SHOW_FORM_QUOTA_INCREASE',
        'SHOW_FORM_EXPIRY_OBJECT',
        'SHOW_FORM_CHANGE_DNS_RECORD',
        'SHOW_FORM_CREATE_INSTANCE_BACKUP',
        'SHOW_CONTAINER_DETAILS',
        'SHOW_CONTAINER_ACCESS_FORM',
        'SHOW_FORM_REVERSE_UN_SET',
        'SHOW_FORM_ADD_LISTENER',
        'SHOW_FORM_IP_DESCRIPTION',
      ];
      this.$store.commit('form/UPDATE_KEY');
      this.toggleModalElement(formsArray, showModal);
      this.$root.$emit('bv::show::modal','os-modal');
    },

    emkModal(showModal) {
        let formsArray = [
          'SHOW_FORM_UPGRADE_EMK',
          'SHOW_FORM_POOLS_EMK',
          'SHOW_FORM_ADDONS_EMK',
          'SHOW_FORM_CREDENTIALS_EMK',
          'SHOW_FORM_MAINTENANCE_EMK',
          'SHOW_FORM_HIBERNATION_EMK',
          'SHOW_FORM_DIRECT_HIBERNATION_EMK',
          'SHOW_FORM_RECONCILE_EMK',
          'SHOW_FORM_ROTATE_KUBECONFIG_EMK',
          'SHOW_FORM_DELETE_EMK',
          'SHOW_FORM_ACCESS_EMK',
          'SHOW_FORM_DNS_EMK',
          'SHOW_FORM_HA_EMK',
          'SHOW_FORM_CREATE_SERVICE_ACCOUNT',
          'SHOW_FORM_RESET_SERVICE_ACCOUNT',
          'SHOW_FORM_DELETE_SERVICE_ACCOUNT',
        ];
        this.toggleModalElement(formsArray, showModal);
        this.$root.$emit('bv::show::modal','kubernetes-modal');
    },

    searchLightPluginNameToHuman: function(name){
      let translations = {
        "OS::Nova::Server" : "Instances",
        "OS::Cinder::Volume" : "Volumes",
        "OS::Cinder::Snapshot" : "Snapshot",
        "OS::Glance::Image" : "Images",
        "OS::Neutron::FloatingIP" : "Floating IPs",
        "OS::Neutron::SecurityGroup" : "Security Groups",
        "OS::Nova::Flavor" : "Flavors",
        "OS::Neutron::Net" : "Networks",
        "OS::Neutron::Port" : "Ports",
        "OS::Neutron::Router" : "Routers",
        "OS::Neutron::Subnet" : "Subnets",
        "OS::Designate::RecordSet" : "Record sets",
        "OS::Designate::Zone" : "DNS Zones",
      };
      return translations[name];
    },

    onCopy: function (e) {
        if (e.text.length > 1000) {
            this.showNotification('success', `Copy successful`);
        } else {
            this.showNotification('success', `You just copied: ${e.text}`);
        }
    },

    onCopyError: function (e) {
        this.showNotification('error', `Failed to copy texts`);
    },

    toggleListItem(value) {
        let indexPosition = this.listData.view.disAbledcolumns.indexOf(value);
        if (indexPosition > -1) {
            this.listData.view.disAbledcolumns.splice(indexPosition, 1);
            this.createQueryParams(this.listData, this.listName);
        } else {
            this.listData.view.disAbledcolumns.push(value);
            this.createQueryParams(this.listData, this.listName);
        }
    },

    toggleHelpBar(value) {
        if (localStorage.getItem('helpbarTab') !== undefined && localStorage.getItem('helpbarTab') !== value) {
            localStorage.setItem('helpbarTab', value);
            this.$store.commit('misc/ACTIVE_HELPBAR', value);
            // this.$store.commit('misc/NEW_NOTIFICATION', false);
        } else {
            localStorage.removeItem('helpbarTab');
            this.$store.commit('misc/ACTIVE_HELPBAR', '');
        }
    },

    switchBillingModal(showModal) {
        let formsArray = [
            'SHOW_FUGA_USAGE',
            'SHOW_FORM_PERSONAL_DETAILS',
            'SHOW_FORM_BUSINESS_DETAILS',
            'SHOW_ADD_PAYMENT_METHOD',
            'SHOW_FORM_CREDIT_CARD',
            'SHOW_FORM_SEPA_DD',
            'SHOW_FORM_SEPA_SOFORT',
            'SHOW_FORM_BILLING_ADDRESS',
            'SHOW_FORM_ADDRESS',
            'SHOW_FORM_PRESENT',
            'SHOW_FORM_LEVEL',
            'SHOW_ADD_VOUCHER',
        ];
        if (showModal === 'cc') {
            this.toggleModalElement(formsArray, 'SHOW_FORM_CREDIT_CARD');
        } else if (showModal === 'sepa-dd') {
            this.toggleModalElement(formsArray, 'SHOW_FORM_SEPA_DD');
        } else if (showModal === 'sofort') {
            this.toggleModalElement(formsArray, 'SHOW_FORM_SEPA_SOFORT');
        } else if (showModal === 'prepaid') {
            this.toggleModalElement(formsArray, 'SHOW_FORM_PREPAID');
        } else {
            this.toggleModalElement(formsArray, showModal);
        }
        this.$root.$emit('bv::show::modal','billing-modal');
    },

    showRecordForm(record) {
        if (record) {
            this.$store.commit('dns/SET_ACTIVE', record);
        } else {
            this.$store.commit('dns/SET_ACTIVE', false);
        }
        this.$store.commit('dns/UPDATE_FORM_KEY');
        this.osModal('SHOW_FORM_CREATE_DNS_RECORD');
    },

    workersFromEmk(workers) {
      // console.log('workersFromEmk', workers)
      let data = [];
        if (workers.length > 0) {
            workers.forEach((workerItems) => {
                // let itemData = {
                //     name: item.name,
                //     flavor: item.machine.type,
                //     flavorType: item.flavorType,
                //     autoScalerMin: item.minimum,
                //     autoScalerMax: item.maximum,
                //     maxSurge: item.maxSurge,
                //     zones: item.zones,
                //     image: item.machine.image,
                //     cri: item.cri,
                // }
                let itemData = {}
                for (const key in workerItems) {
                    if (key === 'machine') {
                        itemData.flavor = workerItems[key].type;
                        itemData.flavorTier = workerItems[key].type.split(".")[0];
                        itemData.image = workerItems[key].image;
                    } else if (key === 'minimum') {
                        itemData.autoScalerMin = workerItems[key]
                    } else if (key === 'maximum') {
                        itemData.autoScalerMax = workerItems[key]
                    } else {
                        itemData[key] = workerItems[key]
                    }
                }
                if (workerItems.volume) {
                    itemData.blockStorage = workerItems.volume.size.split('Gi')[0];
                    itemData.blockStorageType = workerItems.volume.type;
                    itemData.useEphemeral = false;
                } else {
                    itemData.useEphemeral = true;
                }
                itemData.extraLabels = {};
                itemData.labelFieldKey = '';
                itemData.labelField = '';
                itemData.showLabels = false
                data.push(itemData);
            });
        }
      // console.log('workersFromEmk data', data)
      return data;
    },

    workersToEmk(workers) {
      // console.log('workersToEmk', workers)
        let data = [];
        if (workers.length > 0) {
            workers.forEach((pool) => {
                let poolData = {}
                poolData.name = pool.name;
                poolData.minimum = pool.autoScalerMin;
                poolData.maximum = pool.autoScalerMax;
                poolData.maxSurge = pool.maxSurge;
                poolData.zones = pool.zones;
                poolData.cri = pool.name;
                if (!pool.useEphemeral) {
                    poolData.volume = {};
                    poolData.volume.size = pool.blockStorage + 'Gi';
                    poolData.volume.type = pool.blockStorageType;
                }
                poolData.machine = {};
                poolData.machine.type = pool.flavor;
                poolData.machine.image = {};
                poolData.machine.image.name = pool.image.name;
                poolData.machine.image.version = pool.image.version;
                poolData.cri = pool.cri;

                if (pool.labels && Object.keys(pool.labels).length > 0) {
                  poolData.labels = pool.labels;
                } else {
                  poolData.labels = {};
                }

                if (pool.extraLabels) {
                  poolData.labels = { ...poolData.labels, ...pool.extraLabels };
                }
                data.push(poolData);
            })
        }
        // console.log('return data workers', data);
        return data;
    },

    dnsToEmk(dnsData, alreadyCreated) {
        let data = {}
        if (dnsData[0]) {
            let fullDomain = dnsData[0].domainName;
            if (dnsData[0].subdomain) {
                if (dnsData[0].subdomain.endsWith('.')) {
                    fullDomain = dnsData[0].subdomain + dnsData[0].domainName;
                } else {
                    fullDomain = dnsData[0].subdomain + '.' + dnsData[0].domainName;
                }
            }
            data.domain = fullDomain;
            data.providers = [];
            dnsData.forEach((provider, key) => {
                let cleanedData = {
                    "type": "openstack-designate",
                    "secretName": provider.secret,
                    "domains": {
                        "exclude": provider.domains.exclude,
                        "include": provider.domains.include,
                    },
                    "zones": {
                        "exclude": provider.zones.exclude,
                        "include": provider.zones.include,
                    }
                }
                if (!alreadyCreated) {
                    cleanedData.primary = true;
                }
                data.providers.push(cleanedData);
            })
        } else {
          data = {"providers":[]}
        }
        return data;
    },

    dnsFromEmk(dnsData) {
        let data = [];
        if (dnsData && dnsData.providers) {
            dnsData.providers.forEach((item, i) => {
                let dnsConvertedData = {
                    "type": "openstack-designate",
                    "secret": item.secretName,
                    "primary": true,
                    "domainsExcludeInput": '',
                    "domainsIncludeInput": '',
                    "domains": {
                        "exclude": [],
                        "include": [],
                    },
                    "zonesExcludeInput": '',
                    "zonesIncludeInput": '',
                    "zones": {
                        "exclude": [],
                        "include": [],
                    },
                    "domainName": dnsData.domain,
                }

                if (item.domains && item.domains.exclude) {
                    dnsConvertedData.domains.exclude = item.domains.exclude
                }
                if (item.domains && item.domains.include) {
                    dnsConvertedData.domains.include = item.domains.include
                }

                if (item.zones && item.zones.exclude) {
                    dnsConvertedData.zones.exclude = item.zones.exclude
                }
                if (item.zones && item.zones.include) {
                    dnsConvertedData.zones.include = item.zones.include
                }
                data.push(dnsConvertedData);
            });
        }
        return data;
    },

    async sendPushNotification(title, text, image) {
        const showNotification = () => {
            // create a new notification
            const notification = new Notification(title, {
                body: text,
                // icon: image
            });
            setTimeout(() => {
                notification.close();
            }, 10 * 1000);

            // navigate to a URL when clicked
            notification.addEventListener('click', () => {
                window.open('https://my.fuga.cloud', '_blank');
            });
        }

        // show an error message
        const showError = () => {
            console.log('You blocked the notifications');
        }

        // check notification permission
        let granted = false;

        if (Notification.permission === 'granted') {
            granted = true;
        } else if (Notification.permission !== 'denied') {
            let permission = await Notification.requestPermission();
            granted = permission === 'granted' ? true : false;
        }

        // show notification or error
        granted ? showNotification() : showError();
    },

    checkEmkAccess(dontShowMessage) {
        if(this.specificService && !this.emailVerified) {
            if (this.$route.name !== 'home') {
                this.$router.push({name: 'home'});
            }
            if (dontShowMessage) {
                this.showNotification('warn', `Please first verify your email address`);
            }
            return false;
        } else {
            return true;
        }
    },

    validEmkName(value) {
        let pattern = /^[a-z0-9]([-a-z0-9]*[a-z0-9])$/;
        let result = pattern.test(value);
        if (!result) {
            return true;
        } else {
            return false;
        }
    },

    saveNewItems(items, storeName, idName, functionName) {
        let arrayOfIds = []
        if (Array.isArray(items)) {
            items.forEach((itemObject, i) => {
                arrayOfIds.push(itemObject.value[idName])
            });
        } else {
            arrayOfIds.push(items[idName]);
        }
        if (functionName) {
            this.$store.commit(storeName + '/' + functionName, arrayOfIds);
        } else {
            this.$store.commit(storeName + '/NEW', arrayOfIds);
        }
    },

    isNewCheck(storeName, itemId, otherFunction) {
        let newItems = false;
        if (otherFunction) {
            newItems = this.$store.state[storeName][otherFunction];
        } else {
            newItems = this.$store.state[storeName].new;
        }
        if (newItems && Array.isArray(newItems) && newItems.indexOf(itemId) > -1) {
            return true
        } else {
            return false;
        }
    },

    updateResourceData(resourceType, resourceData, otherUpdate) {
      if (resourceType && resourceData) {
      this.$store.commit(resourceType + '/UPDATE_SINGLE', resourceData);
      } else if (this.$router.currentRoute.name === 'volume' || 
                this.$router.currentRoute.name === 'instance' || 
                this.$router.currentRoute.name === 'image' || 
                this.$router.currentRoute.name === 'snapshot' || 
                this.$router.currentRoute.name === 'network' || 
                this.$router.currentRoute.name === 'port' || 
                this.$router.currentRoute.name === 'router') {
          this.$store.commit('misc/UPDATE_DETAIL_DATA');
      } else {
          this.$store.commit('misc/UPDATE_LIST_DATA');
      }
    },

    addDaysToDate(dateData, extraDays) {
      return addDays(dateData, extraDays).getTime();
    },

    showCreateVolume(storeCommit, resourceData) {
        this.$store.commit('volumev3/SET_CURRENT_VOLUME_BACKUP', false);
        this.$store.commit('volumev3/SET_CURRENT', false);
        this.$store.commit('snapshot/SET_CURRENT', false);
        this.$store.commit('image/SET_CURRENT', false);
        if (storeCommit) {
            this.$store.commit(storeCommit, resourceData);
        }
        this.$store.commit('form/UPDATE_KEY');
        this.osModal('SHOW_FORM_CREATE_VOLUME');
    },

    toggleSort(value) {
        if (this.listData.orderData.sort_key !== value) {
            this.listData.orderData.sort_key = value;
        }
        if (this.listName !== 'emk') {
          this.checkListDataLocalStorage(this.listName, this.listData);
          // this.updateResourceData();
        } else {
          this.checkListDataLocalStorage(this.listName, this.listData);
          this.$store.commit('emk/UPDATE_KEY');
        }
    },

    checkOrder(a, b) {
        if (!isNaN(a)) {
          let saveA = a;
          a = b;
          b = saveA;
        }
        if (this.listData.orderData.sort_dir === 'asc') {
          return a == b ? 0 : b > a ? -1 : 1;
        } else {
          return b == a ? 0 : a > b ? -1 : 1;
        }
    },

    toggleSortDir(value) {
        if (value) {
          this.listData.orderData.sort_dir = 'desc';
        } else {
          this.listData.orderData.sort_dir = 'asc';
        }
        this.checkListDataLocalStorage(this.listName, this.listData);
        if (this.listName === 'emk') {
          this.$store.commit('emk/UPDATE_KEY');
        }
    },

    fetchAllEMkResources() {
        this.checkNameSpaces();
        this.fetchEmkCloudProfiles();
        this.fetchGardenerExtensions();
    },
  },
});
